// Query-key factory for the Send Signup Link email typeahead
// (EmailContactTypeahead) on /admin/portal-accounts/send-signup-link.
// Backs `portalAccountsApi.searchContacts(q)` via React Query. Required by
// the stale-after-save gate (queryKey literals must live in *Keys files).

export const portalContactSearchKeys = {
  all: () => ["portal-contact-search"] as const,
  search: (q: string) => ["portal-contact-search", q] as const,
};
